const isAccountRep = accountType => accountType === 'REP';

export { isAccountRep };
